import { useQuery } from 'react-query';

import { tutorialService } from '../tutorial.service';

const getTutorialData = async (appId, storeId) => {
  const response = await tutorialService.getTutorial(appId, storeId);

  // TODO: backend response to be cleaned up before being sent to FE
  const tutorialResponseData = response.Items.Data.RootItems[0];
  const parsedData = {
    BankAccountId: tutorialResponseData.BankAccountId,
    MenuId: tutorialResponseData.MenuId,
    Status: tutorialResponseData.Status,
    Items: [
      {
        ...tutorialResponseData,
      },
    ],
  };

  return parsedData;
};

export default function useTutorialStore(appId, storeId) {
  return useQuery([tutorialService.getTutorialKey, appId, storeId], () =>
    getTutorialData(appId, storeId)
  );
}
